export default __webpack_public_path__ + "static/StevensWood-TFL-Specifcation-ef01abf3ff8cbde5e14f349e62f46929.pdf";